export default "__VITE_ASSET__PBOA1Akw__"